// extracted by mini-css-extract-plugin
export var scrollArea = "_p4-0";